import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { alpha } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';

import Members from '../Members';
import { mislecAPI } from '../../../util/axios';
import Iconify from '../../../theme/iconify/iconify';

function GroupMembers({ _id, users, members, fetchGroups, open, close, setOpen, setMessage, setSeverity }) {
    const { t } = useTranslation();

    const addMember = (id) => {
        //  Data preparation
        const data = {
            id: id
        };

        //  Send data to the server
        mislecAPI.post(`api/groups/${_id}/users`, data)
            .then(res => {
                //  Notify user of success
                setMessage(t(res.data.detail));
                setSeverity('success');
                setOpen(true);

                //  Fetch members
                fetchGroups();
            })
            .catch(error => {
                //  Notify user of error
                setMessage(error.response ? t(error.response.data.detail) : t('api.general.500'));
                setSeverity('error');
                setOpen(true);
            });
    }

    const removeMember = (id) => {
        //  Send data to the server
        mislecAPI.delete(`api/groups/${_id}/users/${id}`)
            .then(res => {
                //  Notify user of success
                setMessage(t(res.data.detail));
                setSeverity('success');
                setOpen(true);

                //  Fetch members
                fetchGroups();
            })
            .catch(error => {
                //  Notify user of error
                setMessage(error.response ? t(error.response.data.detail) : t('api.general.500'));
                setSeverity('error');
                setOpen(true);
            });
    }

    return (
        <Modal
            open={open}
            onClose={() => close(false)}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Paper
                sx={{
                    padding: '24px',
                    minWidth: { xs: '95%', lg: '35%' },
                    maxWidth: { xs: '95%', lg: '35%' },
                }}
            >
                <Typography variant='h6' sx={{ mb: 2 }}>
                    {t('users.modals.groupMembers.title')}
                </Typography>
                <Members
                    users={users}
                    members={members}
                    addMember={addMember}
                    removeMember={removeMember}
                />
                <Stack
                    direction='row'
                    alignItems='center'
                    sx={{
                        mt: 2,
                        justifyContent: 'flex-end'
                    }}
                >
                    <Button
                        variant=''
                        onClick={() => close(false)}
                        sx={{
                            borderRadius: '8px !important',
                            backgroundColor: (theme) => ({
                                xs: alpha(theme.palette.error.main, 0.08),
                                md: 'rgba(33, 43, 54, 0.08)'
                            }),
                            color: {
                                xs: 'error.main',
                                md: 'inherit'
                            },
                            '&:hover': {
                                color: 'error.main',
                                backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08)
                            }
                        }}
                    >
                        {t('users.modals.groupMembers.buttons.close')}
                    </Button>
                </Stack>
            </Paper>
        </Modal>
    );
}

export default GroupMembers;